<template>
  <div class="mt-8 flex justify-center content-center">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  async mounted() {
    window.opener.handleParamsDriver(window.location.href)
    window.close()
  },
}
</script>

<style scoped>
</style>
